exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".device-container[data-v-1543614e]{margin:26px 20px 12px 0;display:flex;flex-direction:column;justify-content:center}.flex-row[data-v-1543614e]{display:flex;flex-direction:row;align-items:center}.el-row[data-v-1543614e]:nth-child(2){margin-top:20px!important;height:18px}.el-row[data-v-1543614e]:nth-child(3){height:18px}.el-row[data-v-1543614e]:nth-child(4){margin-top:10px!important}.device-online[data-v-1543614e]{height:10px;border-radius:5px;background-color:#15cd85;cursor:pointer}.device-offline[data-v-1543614e]{height:10px;border-radius:5px;background-color:#f44;cursor:pointer}.device-status[data-v-1543614e]{width:50px;height:20px}.device-state[data-v-1543614e]{font-size:16px;font-weight:500;color:#333}.device-time[data-v-1543614e]{display:flex;flex-direction:row;justify-content:center;align-items:center;height:20px;border:1px solid #eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1543614e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/Components/DeviceStatus.vue
// module id = 449
// module chunks = 0